export const readFileAsText = file => new Promise((resolve, reject) => {
	const reader = new FileReader()

	reader.addEventListener('load', () => {
		if (!reader.result) {
			reject(new Error('Cannot load file or it is empty'))
		}
		resolve(reader.result)
	})

	reader.addEventListener('error', (err) => {
		reject(err)
	})

	reader.readAsText(file)
})
